import TravianVersion from "./enum/version";
import {DeepPartial} from "../index";
import Tribe from "./enum/Tribe";

export type TravianLegendsFeatureSet = {
    speed: number,
    troopSpeed: number,
    tribeBalancing: {
        roman2023: boolean,
        teuton2024: boolean,
        gaul2024: boolean,
        romanAS2024: boolean,
    },
    enabledPlayableTribes: Array<Tribe>,
    // https://blog.travian.com/2024/07/travian-northern-legends-reimagining-the-battlefield/
    // Some buildings have construction times reduced on AS24
    reducedInfrastructureConstructionTimes: boolean,
    // https://blog.travian.com/2014/01/t4-4-production-crannies-and-hero-bonus/
    // 40% bonus resource production introduced in T4.4
    increasedResourceProduction: boolean,
}

export type TravianKingdomsFeatureSet = {
    speed: number,
    troopSpeed: number,
}
export type TravianVersionWithFeatures = {
    version: TravianVersion.Legends,
    features: TravianLegendsFeatureSet,
} | {
    version: TravianVersion.Kingdoms,
    features: TravianKingdomsFeatureSet,
}

export type TravianVersionWithPartialFeatures = {
    version: TravianVersion.Legends,
    features: DeepPartial<TravianLegendsFeatureSet>,
} | {
    version: TravianVersion.Kingdoms,
    features: DeepPartial<TravianKingdomsFeatureSet>,
}

export const ReducedInfrastructureConstructionTimesAffectedBuildings: Array<number> = [1, 2, 3, 4, 10, 11, 38, 39, 15];